import { create } from 'zustand';

interface ModalDataMap {
  SINGLE_METRIC: { metricId: string };
  FULL_ADD: {};
}

export type ModalType = keyof ModalDataMap;

type ClosedState = {
  modalType: null;
  modalData: null;
};

type ModalStatePairs =
  | {
      [K in ModalType]: {
        modalType: K;
        modalData: ModalDataMap[K];
      };
    }[ModalType]
  | ClosedState;

type ModalState = ModalStatePairs & {
  openModal: <T extends ModalType>(type: T, data: ModalDataMap[T]) => void;
  closeModal: () => void;
};

export const useModalStore = create<ModalState>((set) => ({
  modalType: null,
  modalData: null,
  openModal: (type, data) => set({ modalType: type, modalData: data } as any),
  closeModal: () => set({ modalType: null, modalData: null } as any),
}));
